module.exports = __webpack_public_path__ + "img/vegetta777.b760a058.png";